module.exports = __webpack_public_path__ + "images/ipo-3412ed.png";